// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"a7e20879","499":"6c8eca86","555":"f6935160","639":"f36a9d67","665":"c5101361"}[chunkId] + ".chunk.js";
};